var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "wrapper-table-audit" },
    [
      _c("TableData", {
        attrs: {
          startLoad: _vm.table.startLoadTable(),
          route: _vm.url,
          settings: _vm.table.settings,
          columns: _vm.tblColumns,
          child: _vm.tblChild,
          childTableClass: "table-bordered table-sm table-responsive-sm",
          inlineFilters: _vm.tblFilters,
          btnSearchFilters: false,
          btnClearFilters: false,
          titleData: null,
          tableWrapperClass: "bg-lilac-light",
          tableClass: "table-responsive-sm",
        },
        on: { errorLoad: _vm.showError },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function ({
              fieldColumns,
              actionColumns,
              row,
              index,
              hasChild,
              childId,
            }) {
              return [
                _vm._l(fieldColumns, function (column, cIndex) {
                  return _c("td", {
                    key: `group-${index}-column-${cIndex}`,
                    class: [
                      column.class,
                      column.field == "event"
                        ? `event-${row[column.field]}`
                        : "",
                    ],
                    domProps: {
                      innerHTML: _vm._s(_vm.columnValue(row, column)),
                    },
                  })
                }),
                _vm._v(" "),
                actionColumns.length
                  ? [
                      _c(
                        "ColumnActions",
                        { attrs: { row: row, index: index } },
                        [
                          hasChild
                            ? _c(
                                "li",
                                {
                                  staticClass: "list-group-item",
                                  attrs: {
                                    role: "button",
                                    "data-toggle": "collapse",
                                    "aria-expanded": "false",
                                    "data-target": `#${childId}`,
                                    "aria-controls": `${childId}`,
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "fas fa-ellipsis action",
                                    attrs: {
                                      "data-toggle": "tooltip-city",
                                      "data-placement": "left",
                                      title: _vm.$t(
                                        `${_vm.idPanel}.list.actions.list-modified`
                                      ),
                                    },
                                  }),
                                ]
                              )
                            : _vm._e(),
                        ]
                      ),
                    ]
                  : _vm._e(),
              ]
            },
          },
          {
            key: "row-child",
            fn: function ({
              row,
              columns,
              index,
              property,
              rowParent,
              indexParent,
            }) {
              return _vm._l(columns, function (column, cIndex) {
                return _c(
                  "td",
                  {
                    key: `group-${indexParent}-child-${index}-column-${cIndex}`,
                    class: column.class,
                  },
                  [
                    column.field == "key"
                      ? [
                          _c("span", { staticClass: "text-medium" }, [
                            _c("em", [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t" +
                                  _vm._s(
                                    _vm.$t(
                                      `${_vm.translatePrefix}.${rowParent?.model}.${property}`
                                    )
                                  ) +
                                  "\n\t\t\t\t\t\t"
                              ),
                            ]),
                          ]),
                        ]
                      : column.field in row
                      ? [
                          _c("ValueAudit", {
                            attrs: {
                              parentKeyBind: `group-${indexParent}-child-${index}-column-${cIndex}`,
                              value: row[column.field],
                            },
                          }),
                        ]
                      : [_vm._v("\n\t\t\t\t\t \n\t\t\t\t")],
                  ],
                  2
                )
              })
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }